import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import Snackbar from "../../../Snackbar";
import QueOptionsForResponse from "./QueOptionsForResponse";
import { evaluateQuestion } from "./AnswerEvaluateEngine";
import { handleAttemptTestActions } from "../../../store/actions/QuizAPI/createNewMockTest";
import { useLocation } from "react-router-dom";

import { useParams } from "react-router-dom";
import { sec } from "mathjs";
import Loading from "../../Loading/Loading";
const MockTestSubmitInfoTable =({setSubmitStatus,mockTestCard1Object,setCloseSubmitInfoPopUp,setCloseInstructionsPopUp,sectionsArr,
  sendBackTestResultSummary
})=>{

   const {courseId} = useParams();
 const {itemId} = useParams();

   const dispatch = useDispatch();
    const { pathname, search, hash } = useLocation();
   
         
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
    const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
  const [attemptData, setAttemptData] = useState(null); 
  
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      
               const user = useSelector((state)=>state?.user?.user);
      const data = [
    { section: "Physics MCQs", total: 20, attempted: 2, unattempted: 2, marked: 3, unseen: 16 },
    { section: "Physics Numerical Questions", total: 10, attempted: 0, unattempted: 0, marked: 0, unseen: 10 },
    { section: "Chemistry MCQs", total: 20, attempted: 0, unattempted: 0, marked: 0, unseen: 20 },
    { section: "Chemistry Numerical Questions", total: 10, attempted: 0, unattempted: 0, marked: 0, unseen: 10 },
    { section: "Mathematics MCQs", total: 20, attempted: 0, unattempted: 0, marked: 0, unseen: 20 },
    { section: "Mathematics Numerical Questions", total: 10, attempted: 0, unattempted: 0, marked: 0, unseen: 10 },
  ];
                       
                       
                                  
                                  
            const [isLockSections, setIsLockSections] = useState();
                               
                              const [animate, setAnimate] = useState(false);
                
                 const [loader , setLoader] =useState({status:false});
        
            
                   const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                   const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                  );
                  
                      const userData =useSelector((state)=>state?.user?.user);
                     const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                     const appId = useSelector((state)=>state?.user?.user?.appId);
                      
 const [itemArr, setItemArr] = useState([]);
  
  
    
       const fireHandleAttemptTestActions=(actionType)=>{
      
     
setLoader({status:true});
  
               if(!userEmail) { dispatch({ type: "LoginSignUpPopUp",payload:"login"})}
            let   requestData={};
           
               if(actionType=="submitAttempt"){
            requestData={userEmail:userEmail?userEmail:"",fullUrl : window.location.origin + pathname + search + hash,
          currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,testId:itemId,
        actionType:"submitAttempt"}
           } 
          
           
                   const apiData = dispatch(handleAttemptTestActions(requestData));
                   /* get response as Promise   */
                   apiData.then(response => {
                  
             sendBackTestResultSummary(response);
                     
                 
                   }).catch(error => {
                  
                     //popup of error Info
                     setResponseMessage("Something Went Wrong...");
                       
                     setSnackbarColor("#958FDA");
                  
                     
                      
                 setLoader({status:false});
                 
                 setSnackbarVisible(true);
                 setTimeout(()=>{
                   
                   setSnackbarVisible(false);
                  
                    
                 },3000)
                    
                   });
              } 
                const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };
              
              return(<>
 <div    onClick={()=>setCloseSubmitInfoPopUp(false)} className="mockTestV1PopUpSubmitInfoOpacitySubmitInfo"  style={{cursor:"pointer"}}> </div>
        <div   className="mockTestV1PopUpSubmitInfo" style={{borderRadius: '0px'}}> 
          
              
{<Loading  Load={loader?.status}/>}
        <h2 align="center" >   <span className="" style={{fontSize:"34px"}} >Test Attempt Info </span> </h2>
      
 
<div style={{overflowY:"auto",paddingBottom:"50px",minHeight:"300px"}}>
      <div style={styles.tableWrap}> 
          <table style={styles.table}>
            
            <thead>
              <tr style={styles.headRow}>
                <th style={styles.th}>Section</th>
                <th style={styles.th}>Time Spent</th>
                <th style={styles.th}>Total Q`s</th>
                <th style={styles.th}>Marks</th>
                <th style={styles.th}>Attempted</th>
                <th style={styles.th}>Unattempted</th>
                <th style={styles.th}>Marked</th>
                <th style={styles.th}>Unseen</th>
              </tr>
            </thead>

            <tbody>
              {sectionsArr?.map((row, idx) => (
                <tr key={idx} style={styles.row}>
                  <td style={styles.tdSection}>{row.sectionName}</td>
                  <td style={styles.td}>{sectionsArr[idx]?.sectionStats?.timeSpent?formatTime(sectionsArr[idx]?.sectionStats?.timeSpent):formatTime(0)}</td>
                  <td style={styles.td}>{sectionsArr[idx]?.secQuestions?.length}</td>
                  <td style={styles.td}>{sectionsArr[idx]?.sectionStats?.totalMarks}</td>
                 <td style={styles.td}>{sectionsArr[idx]?.sectionStats?.answered}</td>
                  <td style={styles.td}>{sectionsArr[idx]?.sectionStats?.visited}</td>
                  <td style={styles.td}>{sectionsArr[idx]?.sectionStats?.markedAndAnswered+sectionsArr[idx]?.sectionStats?.markedAndNotAnswered}</td>
                  <td style={styles.td}>{sectionsArr[idx]?.sectionStats?.notVisited}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

       <div style={{display:"flex",justifyContent:"center"}}></div>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"10px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
    <button  onClick={()=>{setCloseSubmitInfoPopUp(false)}}    className=" MocktestSubmitInfoBtn"  type="submit"
 > Cancel </button>
<button  onClick={()=>{fireHandleAttemptTestActions('submitAttempt')}}   style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestSubmitInfoBtn"  type="submit"
 > Submit Test </button>
</div> 
</div></div>
<style>{`



 .mockTestSubmitInfoTextbox, .mockTestSubmitInfoTextbox:hover, .mockTestSubmitInfoTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  
.MocktestSubmitInfoBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1SubmitInfo {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.mockTestV1PopUpSubmitInfoOpacitySubmitInfo{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.061);
        z-index:9999999999 !important}
        
        .mockTestV1PopUpSubmitInfo{position:fixed;
    left:20%;
    right:20%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:0%;bottom:0%;
    padding:15px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
    .mockTestV1PopUpSubmitInfo{position:fixed;top:0px;
        left:20%;
        right:20%;top:22%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
  .mockTestV1PopUpSubmitInfo{position:fixed;top:0px;
                left:20%;
                right:20%;top:22%;
               }} 

/* xs */
@media (max-width: 767px) {
    
    .mockTestV1PopUpSubmitInfo{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style>
    </>)
}
const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    padding: 20,
  },
  modal: {
    width: "900px",
    maxWidth: "95vw",
    backgroundColor: "#fff",
    borderRadius: 6,
    boxShadow: "0 10px 35px rgba(0,0,0,0.25)",
    overflow: "hidden",
  },
  tableWrap: {
    maxHeight: "420px",
    overflow: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 14,
  },
  headRow: {
    backgroundColor: "#f3d7c6", // light peach header like screenshot
  },
  th: {
    textAlign: "left",
    padding: "14px 12px",
    border: "1px solid #ddd",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  row: {
    backgroundColor: "#fff",
  },
  tdSection: {
    padding: "12px",
    border: "1px solid #ddd",
    fontWeight: 500,
  },
  td: {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    gap: 15,
    padding: 18,
    borderTop: "1px solid #eee",
    backgroundColor: "#fff",
  },
  cancelBtn: {
    padding: "10px 18px",
    border: "1px solid #ccc",
    backgroundColor: "#f5f5f5",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 600,
  },
  submitBtn: {
    padding: "10px 18px",
    border: "none",
    backgroundColor: "#ffc107", // yellow submit like screenshot
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 700,
  },
};
export default MockTestSubmitInfoTable;

